export default __webpack_public_path__ + "static/media/Screenshot 2023-07-28 at 4.41.49 PM.3fa3b0e5.png";